/**
 * Parse the meter value `current` string (amps) into a single number.
 * Multi-phase readings may arrive as several numbers (e.g. "16.0 / 15.8 / 16.1");
 * the highest phase is returned. Returns null when no number is present.
 */
export function parseCurrentAmps(current: string | null | undefined): number | null {
  if (!current) return null;
  const numbers = (current.match(/-?\d+(?:\.\d+)?/g) ?? []).map(Number);
  return numbers.length ? Math.max(...numbers) : null;
}
